import React, { useState, useEffect } from "react";
import { Drawer } from "antd";
import { ArrowLeftOutlined, StarOutlined } from "@ant-design/icons";
import styles from "./styles/NewAddPanel.module.css";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { getHeroIcon } from "../_helpers/heroicons";

export default function MobileNewAddPanel({
    open,
    onClose,
    panelConfig,
    renderContent,
}) {
    const [activePanel, setActivePanel] = useState(null);

    useEffect(() => {
        if (!open) setActivePanel(null);
    }, [open]);

    const handleClose = () => {
        setActivePanel(null);
        onClose();
    };

    const panelInfo = panelConfig.find((p) => p.key === activePanel);

    return (
        <Drawer
            open={open}
            onClose={handleClose}
            placement="bottom"
            height="90vh"
            title={null}
            closable={false}
            styles={{ body: { padding: 0, overflow: "auto" } }}
        >
            {activePanel !== null ? (
                <QurealSection
                    header={
                        <SectionHeader
                            heading={panelInfo?.label}
                            icon={
                                <ArrowLeftOutlined
                                    style={{
                                        fontSize: "1.5rem",
                                        color: "gray",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setActivePanel(null)}
                                />
                            }
                        />
                    }
                >
                    <div
                        className={styles.mobilePanelContent}
                        style={{ animation: "slideInRight 0.2s ease-out" }}
                    >
                        {renderContent(activePanel)}
                    </div>
                </QurealSection>
            ) : (
                <QurealSection
                    header={
                        <SectionHeader
                            heading="Create Content"
                            icon={
                                null
                                // getHeroIcon("sparkles", {
                                //     fontSize: "1rem",
                                //     color: "gray",
                                // })
                                // <StarOutlined
                                //     style={{
                                //         fontSize: "1.5rem",
                                //         color: "gray",
                                //     }}
                                // />
                            }
                        />
                    }
                >
                    <div className={styles.mobileCardsContainer}>
                        <p className={styles.mobileCardsHeading}>
                            What would you like to create?
                        </p>
                        <div className={styles.cardsGrid}>
                            {panelConfig.map((panel) => (
                                <div
                                    key={panel.key}
                                    className={`${styles.card} ${
                                        panel.disabled
                                            ? styles.cardDisabled
                                            : ""
                                    }`}
                                    onClick={() =>
                                        !panel.disabled &&
                                        setActivePanel(panel.key)
                                    }
                                    style={{
                                        "--card-color": panel.color,
                                        "--card-bg": panel.bgColor,
                                    }}
                                >
                                    <div className={styles.cardIconWrap}>
                                        {React.createElement(panel.icon, {
                                            style: {
                                                fontSize: 24,
                                                color: panel.disabled
                                                    ? "#bbb"
                                                    : panel.color,
                                            },
                                        })}
                                    </div>
                                    <span className={styles.cardLabel}>
                                        {panel.label}
                                    </span>
                                    <span className={styles.cardDesc}>
                                        {panel.description}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </QurealSection>
            )}
        </Drawer>
    );
}
